import * as store from '@attain-apps/fe/web/main/lib/store'

import type * as models from './models'
import { State } from './state'

/**
 * Core actions for this feature
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /* eslint-disable sort-keys */
    render: store.actions.request({
      input: store.actions.Data.asIs<models.page.Rendering.Request>(),
      output: store.actions.Data.asIs<models.page.Rendering>(),
      reducers: {
        request: ({ state }) => {
          state = State.setRenderingLoading(state, { isLoading: true })
          state = State.deleteRendering(state)
          return state
        },
        success: ({ state, data: { response } }) =>
          State.setRendering(state, response),
        error: ({ state, data: { error } }) =>
          State.setRenderingError(state, { error }),
        cancellation: ({ state }) =>
          State.setRenderingLoading(state, { isLoading: false }),
      },
    }),
    setContext: store.actions.standalone({
      data: store.actions.Data.asIs<
        models.page.Rendering.Context | undefined
      >(),
      reducer: () => State.INITIAL,
    }),

    /* eslint-enable sort-keys */
  } as const satisfies store.actions.Config.Constraint<State>
}
